import { jsx } from 'react/jsx-runtime';
import Default from 'react-bootstrap/Offcanvas';

const _OffCanvas = ({ children, show, handleClose, ...rest })=>{
    return jsx(Default, {
        show: show,
        onHide: handleClose,
        ...rest,
        children: children
    });
};
const defaultComponents = {
    Body: Default.Body,
    Header: Default.Header,
    Title: ({ children })=>jsx(Default.Title, {
            children: jsx("h2", {
                className: "p strong",
                children: children
            })
        })
};
const OffCanvas = Object.assign(_OffCanvas, defaultComponents);

export { OffCanvas };
